export default [
    {
        path: '/software-services',
        name: 'softwareServicesList',
        component: () => import(/* webpackChunkName: "softwareServices" */ '../views/List.vue'),
        props: true,
    },
    {
        path: '/software-services/:id',
        name: 'softwareServicesView',
        component: () => import(/* webpackChunkName: "softwareServices" */ '../views/View.vue'),
        props: true,
    },
]